import ReactDOM from "react-dom/client";

import "../index.scss";
import "../tailwind.css";
import "react-toastify/dist/ReactToastify.min.css";

// load xyflow styling
import "@xyflow/react/dist/style.css";

import { App } from "./App";
import "../i18n";
import { initErrorReporting } from "../ErrorReporting";
initErrorReporting();

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
